import React, { useRef, useState, useEffect } from 'react'
import styled from '@emotion/styled'
import config from 'Config'
import RemarksService from 'Services/remarks'
import { sortMethods } from 'Root/../../shared/sorting'

import { Flex, Image } from 'lese'

const PrintImage = styled(Image)`
  cursor: pointer;
  width: 30px;
  height: 30px;
`

const IFrameContent = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 800px;
  height: 1px;
`

export default ({ encounter }) => {
  const contentElem = useRef(null)
  const [printMode, setPrintMode] = useState(false)
  const [remarks, setRemarks] = useState()

  useEffect(async () => {
    setPrintMode(false)
    let allRemarks = await RemarksService.get({ encounterId: encounter.id, type: 'comments' })
    allRemarks = allRemarks
      .sort((a, b) => sortMethods.date(a.date, b.date))
      .map(item => {
        return {
          date: new Intl.DateTimeFormat('en', {
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: 'numeric'
          }).format(new Date(item.date)),
          text: item.text,
          author: item.author
        }
      })

    setRemarks(allRemarks)
  }, [encounter])

  // no selected encounter, nothing to print
  if (Object.keys(encounter).length <= 0) {
    return
  }

  let url = `${config.docportal.getUrl()}/docportal/#/getFaxReport/${encounter.PMHID}?token=${
    encounter.token
  }`

  if (encounter.isExternal) {
    url = `${config.docportal.getUrl()}/docportal/#/getExternalFaxReport/${encounter.PMHID}?token=${
      encounter.token
    }`
  }

  const handlePrint = () => {
    if (contentElem) {
      contentElem.current.contentWindow.postMessage(
        { action: 'print', comments: remarks },
        `${config.docportal.getUrl()}`
      )
    }
  }

  return (
    <>
      <PrintImage
        src="/print.svg"
        title="Print or save as PDF"
        onClick={() => {
          if (printMode) {
            handlePrint()
          } else {
            setPrintMode(true)
          }
        }}
      />
      {printMode && (
        <IFrameContent>
          <iframe
            title={encounter.PMHID}
            src={url}
            ref={contentElem}
            width={800}
            onLoad={() => {
              setTimeout(() => {
                handlePrint()
              }, 1000)
            }}
          />
        </IFrameContent>
      )}
    </>
  )
}
